module.exports = __webpack_public_path__ + "static/media/img3-2.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/biosense/diff/img3-2.png
// module id = 1436
// module chunks = 3